import script from "./KetQuaHocTap.vue?vue&type=script&lang=ts&setup=true"
export * from "./KetQuaHocTap.vue?vue&type=script&lang=ts&setup=true"

import "./KetQuaHocTap.vue?vue&type=style&index=0&id=7ca9d1ff&lang=css"

const __exports__ = script;

export default __exports__